// @ts-nocheck
// "Schick mir meine Woche" (docs/HOMEPAGE_FUNNEL.md 5; API: vhp-planner src/lib/weekDrafts.ts). A visitor with a free
// week preview saves it by e-mail: mail 1 has their first day with portions and a link (?week=<token>) that opens the
// week on any device, e.g. Safari after Instagram's browser, or the laptop. The row on the preview opens the sheet;
// leaving the preview opens it once by itself. The planner's side (what to save, applying a saved draft, leaving) comes
// from assets/vhp-planner-funnel.js through attach(). The address is never kept in the browser: this browser only
// remembers that the sheet came up on leaving and that a week was saved (localStorage vhp_week_mail).
// Nothing shows until the API says it can send (GET /api/week-draft: the Resend sender for mail 1, the Klaviyo list for
// the tips box), so missing keys never end in "Hat nicht geklappt".
(() => {
  'use strict';

  if (window.vhpWeekMail) return;

  const tr = window.vhpT; // snippets/vhp-i18n.liquid
  const KEY = 'vhp_week_mail';
  const TOKEN_RE = /^[A-Za-z0-9_-]{24}$/;
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const TOAST_MS = 5000;

  const read = () => {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY) || 'null');
      return raw && typeof raw === 'object' ? raw : {};
    } catch (e) {
      return {};
    }
  };
  const write = (patch) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ ...read(), ...patch }));
    } catch (e) {
      /* private mode: the exit sheet may come up again next time */
    }
  };

  let api = null;
  let source = 'row';
  let afterClose = null;
  let sending = false;

  const $ = (sel, root = document) => root.querySelector(sel);
  const dialog = () => $('[data-vhp-weekmail]');

  // What the API can do right now ({ mail, followups }); null until it answered. Kept for the visit (10 minutes).
  const READY_KEY = 'vhp_week_mail_ready';
  const READY_MS = 10 * 60 * 1000;
  let ready = null;
  const loadReady = async () => {
    try {
      const kept = JSON.parse(sessionStorage.getItem(READY_KEY) || 'null');
      if (kept && Date.now() - Number(kept.at || 0) < READY_MS) {
        ready = kept;
        return;
      }
    } catch (e) {
      /* no storage: ask the API */
    }
    try {
      const res = await fetch(`${api.apiBase}/api/week-draft`, { credentials: 'omit' });
      const body = res.ok ? await res.json() : null;
      ready = { mail: body?.mail === true, followups: body?.followups === true, at: Date.now() };
      sessionStorage.setItem(READY_KEY, JSON.stringify(ready));
    } catch (e) {
      // Offline or an older API: nothing to offer on this page (not kept, the next page asks again).
      ready = ready || { mail: false, followups: false, at: 0 };
    }
  };
  const offerable = () => ready?.mail === true && Boolean(api?.canSave());

  const paintRow = () => {
    const row = $('[data-vhp-weekmail-open]');
    if (!row || !api) return;
    row.hidden = !offerable();
    const note = row.querySelector('[data-vhp-weekmail-row-note]');
    if (note) {
      if (!note.dataset.plain) note.dataset.plain = note.textContent;
      note.textContent = read().saved ? tr('planner.weekmail_saved') : note.dataset.plain;
    }
  };

  const showError = (text) => {
    const el = $('[data-vhp-weekmail-error]', dialog());
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  };

  const setBusy = (on) => {
    sending = on;
    const btn = $('[data-vhp-weekmail-send]', dialog());
    if (!btn) return;
    if (!btn.dataset.idle) btn.dataset.idle = btn.textContent;
    btn.disabled = on;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.textContent = on ? tr('planner.weekmail_sending') : btn.dataset.idle;
  };

  const showPane = (done) => {
    const dlg = dialog();
    $('[data-vhp-weekmail-ask]', dlg).hidden = done;
    $('[data-vhp-weekmail-done]', dlg).hidden = !done;
  };

  // Since 2026-11-03 (Maxim, docs/email/SIGNUPS.md) the newsletter comes with the week, said plainly in the small print
  // (no tips box): while the Klaviyo list is set up, the small print is the newsletter line.
  const paintOptin = () => {
    const dlg = dialog();
    if (!dlg) return;
    const opt = $('[data-vhp-weekmail-opt]', dlg);
    const on = ready?.followups === true;
    if (opt) opt.hidden = true;
    const withOptin = $('[data-vhp-weekmail-note-optin]', dlg);
    const plain = $('[data-vhp-weekmail-note]', dlg);
    if (withOptin) withOptin.hidden = !on;
    if (plain) plain.hidden = on && Boolean(withOptin);
  };

  // from: 'row' (the preview's row) or 'exit' (leaving the preview, once); then: what happens once the sheet closes.
  const open = (from, then = null) => {
    const dlg = dialog();
    if (!api || !dlg || typeof dlg.showModal !== 'function' || dlg.open) return false;
    source = from;
    afterClose = then;
    showPane(false);
    showError('');
    setBusy(false);
    const cancel = $('[data-vhp-weekmail-cancel]', dlg);
    if (cancel) cancel.textContent = tr(from === 'exit' ? 'planner.weekmail_no' : 'planner.weekmail_later');
    paintOptin();
    dlg.showModal();
    api.step('week_ask', from);
    return true;
  };

  const send = async () => {
    const dlg = dialog();
    if (!api || !dlg || sending) return;
    const input = $('input[name="email"]', dlg);
    const email = String(input?.value || '').trim();
    if (!EMAIL_RE.test(email)) {
      showError(tr('planner.weekmail_err_email'));
      input?.focus();
      return;
    }
    const payload = api.payload();
    if (!payload) {
      showError(tr('planner.weekmail_err'));
      return;
    }
    const optin = $('input[name="followups"]', dlg);
    const followups = ready?.followups === true;
    showError('');
    setBusy(true);
    let res = null;
    try {
      // text/plain: no preflight (like the events beacon).
      res = await fetch(`${api.apiBase}/api/week-draft`, {
        method: 'POST',
        credentials: 'omit',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({
          email,
          followups,
          ...payload,
          locale: api.locale,
          website: $('input[name="vhp_trap"]', dlg)?.value || '',
        }),
      });
    } catch (e) {
      res = null;
    }
    setBusy(false);
    if (res?.ok) {
      write({ saved: new Date().toISOString() });
      // The week signup is a newsletter signup and makes the background account (vhp-planner src/lib/saverAccount.ts):
      // the same keys as assets/vhp-mail-signup.js, so the menu row goes and her likes sync (assets/vhp-account.js).
      const data = await res.json().catch(() => ({}));
      try {
        if (followups) {
          const known = JSON.parse(localStorage.getItem('vhp_mail_signup') || '{}');
          localStorage.setItem('vhp_mail_signup', JSON.stringify({ ...known, newsletter: new Date().toISOString() }));
        }
        if (data?.account?.customerId && data?.account?.token) {
          localStorage.setItem('vhp_guest_account', JSON.stringify({ customerId: String(data.account.customerId), token: data.account.token, at: new Date().toISOString() }));
          window.dispatchEvent(new CustomEvent('vhp:guest-account'));
        }
      } catch (e) {
        /* private mode: the week link in the mail still works */
      }
      api.step('week_saved', source);
      const text = $('[data-vhp-weekmail-done-text]', dlg);
      if (text) {
        text.textContent = tr('planner.weekmail_done', { email });
        if (followups) text.textContent += ` ${tr('planner.weekmail_done_optin')}`;
      }
      if (input) input.value = '';
      if (optin) optin.checked = false;
      showPane(true);
      paintRow();
      return;
    }
    const body = res ? await res.json().catch(() => null) : null;
    if (body?.error === 'rate_limited') showError(tr('planner.weekmail_err_limit'));
    else if (body?.error === 'bad_email') showError(tr('planner.weekmail_err_email'));
    else showError(tr('planner.weekmail_err'));
    // The sender went away meanwhile: the row goes until the API can send again.
    if (body?.error === 'mail_off') {
      ready = { mail: false, followups: false, at: Date.now() };
      try {
        sessionStorage.setItem(READY_KEY, JSON.stringify(ready));
      } catch (e) {
        /* this page only */
      }
      paintRow();
    }
  };

  // Leaving the preview (or the plans) without a saved week: the sheet comes up once per browser, then they leave.
  const offerOnExit = (leave) => {
    if (!offerable()) return false;
    const seen = read();
    if (seen.saved || seen.asked) return false;
    if (!open('exit', leave)) return false;
    write({ asked: new Date().toISOString() });
    return true;
  };

  // ---------- restore link (?week=<token>) ----------

  const linkToken = () => {
    const token = new URLSearchParams(location.search).get('week') || '';
    return TOKEN_RE.test(token) ? token : null;
  };

  // The token leaves the address bar once it has been used (a reload doesn't restore again, a shared URL carries none).
  const dropLink = () => {
    const url = new URL(location.href);
    if (!url.searchParams.has('week')) return;
    url.searchParams.delete('week');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  };

  // { draft } | { gone: true } (expired or unknown) | { error: true } (network / server: the link stays for a reload).
  const fetchDraft = async (token) => {
    if (!api) return { error: true };
    try {
      const res = await fetch(`${api.apiBase}/api/week-draft/restore`, {
        method: 'POST',
        credentials: 'omit',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({ token }),
      });
      if (res.status === 404 || res.status === 400) return { gone: true };
      if (!res.ok) return { error: true };
      const body = await res.json();
      return body?.draft ? { draft: body.draft } : { error: true };
    } catch (e) {
      return { error: true };
    }
  };

  let toastTimer = 0;
  const toast = (text) => {
    const el = $('[data-vhp-weekmail-toast]');
    if (!el) return;
    el.textContent = text;
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-on');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => {
      el.classList.remove('is-on');
      window.setTimeout(() => {
        el.hidden = true;
      }, 300);
    }, TOAST_MS);
  };

  // ---------- wiring ----------

  const wire = (funnel) => {
    const dlg = dialog();
    if (dlg && !dlg.dataset.wired) {
      dlg.dataset.wired = '1';
      $('[data-vhp-weekmail-form]', dlg)?.addEventListener('submit', (event) => {
        event.preventDefault();
        send();
      });
      dlg.addEventListener('click', (event) => {
        if (event.target.closest('[data-vhp-weekmail-cancel], [data-vhp-weekmail-close]')) dlg.close();
      });
      // Every way out (Nein danke, Alles klar, Esc, the phone's back on the sheet) ends the same: on leaving, they leave.
      dlg.addEventListener('close', () => {
        const then = afterClose;
        afterClose = null;
        if (then) then();
      });
    }
    $('[data-vhp-weekmail-open]')?.addEventListener('click', () => open('row'));
    funnel.addEventListener('vhp:render', (event) => {
      if (event.detail?.screen === 'preview') paintRow();
    });
  };

  // planner: { apiBase, locale, enabled (section setting on, not a subscriber), canSave(), payload() → { draft, day } |
  // null, step(name, value) }
  const attach = (planner) => {
    api = planner;
    const funnel = document.querySelector('[data-vhp-funnel]');
    if (funnel) wire(funnel);
    if (planner.enabled) loadReady().then(paintRow);
    // canOffer: the sender is set up, there is a week to save and it isn't saved yet (the paywall's "Noch nicht?" line,
    // docs/PLANNER_PAGE_FUNNEL.md 3.2, opens the sheet with open('paywall')).
    const canOffer = () => offerable() && !read().saved;
    return { offerOnExit, linkToken, dropLink, fetchDraft, toast, open, canOffer };
  };

  window.vhpWeekMail = { attach };
})();
